export const keys = [
  { label: 'Received Date/Time',
    key: 'date' },
  { label: 'Service Type',
    key: 'service_name' },
  { label: 'Job Status',
    key: 'your_action' },
  { label: 'Current Status',
    key: 'current_status' },
];
